const OPEN_BET_LANGUAGES = {
  'de-at': 'de-de',
};

export const getObLocale = (locale) => OPEN_BET_LANGUAGES[locale] || locale;
